import type { en } from "./en.ts";

export const fr: typeof en = {
    CreateMenu: {
        newGoodVibe: "Nouvelle Bonne Vibe",
        newFeedback: "Nouveau feedback"
    },
    Navigation: {
        home: {
            label: "Accueil",
            description: "Votre point quotidien"
        },
        "manager-impact": {
            label: "Mon impact en tant que gestionnaire"
        }
    },
    HomePage: {
        title: "Accueil",
        error: "Nous n'avons pas pu charger votre tableau de bord pour le moment.",
        liveRegion: {
            loading: "Chargement…"
        }
    },
    Errors: {
        retry: "Réessayer",
        retrying: "Nouvel essai…",
        reassurance: "Veuillez réessayer plus tard.",
        refreshBanner: "Impossible d'actualiser — affichage des derniers résultats."
    },
    HomeAgentPanel: {
        greeting: {
            morning: "👋 Bonjour, {{name}}.",
            afternoon: "👋 Bon après-midi, {{name}}.",
            evening: "👋 Bonsoir, {{name}}."
        },
        inputLabel: "Posez une question à votre agent",
        inputPlaceholder: "Demandez n'importe quoi sur votre équipe ou votre entreprise",
        sendLabel: "Envoyer à votre agent",
        quickPrompts: {
            teamDoing: "Comment va mon équipe?",
            worthAttention: "Qu'est-ce qui mérite mon attention?",
            whoToRecognize: "Qui devrais-je reconnaître cette semaine?"
        }
    },
    HomePerformanceCard: {
        badge: "Cycle d'évaluation actif",
        empty: "Aucun cycle d'évaluation actif",
        opensInNewTab: "S'ouvre dans un nouvel onglet",
        rows: {
            selfReview: "Autoévaluations",
            managerReview: "Gestionnaire",
            peerReview: "Pairs",
            upwardReview: "Ascendantes"
        }
    },
    HomePerformanceCarousel: {
        counter: "{{current}} sur {{total}}",
        previous: "Cycle précédent",
        next: "Cycle suivant"
    },
    HomeNewAndOutstanding: {
        heading: "Nouveautés et en attente",
        empty: "Vous êtes à jour — rien de nouveau pour votre équipe.",
        reviewsToWriteNoun_one: "évaluation à rédiger",
        reviewsToWriteNoun_other: "évaluations à rédiger",
        reviewsToWriteShowMore_one: "Afficher 1 de plus",
        reviewsToWriteShowMore_other: "Afficher {{count}} de plus",
        reviewsToWriteShowLess: "Afficher moins",
        reviewerAssignmentsNoun_one: "désignation d'évaluateurs à faire",
        reviewerAssignmentsNoun_other: "désignations d'évaluateurs à faire",
        assignment: {
            peer: "Désigner les pairs qui évalueront {{name}}",
            upward: "Désigner les évaluateurs ascendants pour {{name}}"
        },
        review: {
            self: "Votre autoévaluation",
            managerOf: "Évaluation du gestionnaire de {{name}}",
            peerOf: "Évaluation par les pairs de {{name}}",
            upwardOf: "Évaluation ascendante de {{name}}",
            due: "Échéance {{date}}"
        },
        badges: {
            unreadFeedback: "feedback non lus",
            newGoodVibes_one: "nouvelle Bonne Vibe pour moi",
            newGoodVibes_other: "nouvelles Bonnes Vibes pour moi",
            unseenReportsGoodVibes_one: "Bonne Vibe non vue pour mes subordonnés",
            unseenReportsGoodVibes_other: "Bonnes Vibes non vues pour mes subordonnés",
            goalUpdates: "mises à jour d'objectifs récentes"
        }
    },
    HomeMyTeam: {
        heading: "Mon équipe",
        empty: "Aucun membre d'équipe",
        actions: {
            label: "Actions pour {{name}}",
            sendGoodVibes: "Envoyer des Bonnes Vibes",
            openNextOneOnOne: "Ouvrir le prochain 1:1"
        },
        scope: {
            ariaLabel: "Portée des subordonnés",
            allReports: "Tous les subordonnés",
            directReports: "Subordonnés directs"
        },
        emptyDirect: "Aucun subordonné direct"
    },
    HomeBringYourTeamIn: {
        heading: "Intégrez votre équipe",
        description: "Synchronisez à partir de votre SIRH, Slack, Microsoft ou Google pour garder votre équipe à jour. Vous choisissez qui est synchronisé.",
        connectHris: "Connecter votre SIRH",
        addManually: "Ou ajoutez des personnes manuellement",
        uploadSpreadsheet: "Téléverser un tableur",
        invitePeople: "Inviter des personnes",
        modalBody: "La mise en place de votre équipe se fait pour l'instant dans Workleap Classic. Nous allons vous y amener. Rien ne sera perdu."
    },
    ManagerImpactReportPage: {
        title: "Mon impact en tant que gestionnaire",
        subtitle: "Comment vous impactez vos subordonnés directs.",
        betaBadge: "Bêta",
        breadcrumb: {
            ariaLabel: "Fil d'Ariane",
            home: "Accueil"
        },
        howToImprove: "Comment m'améliorer",
        empty: "Votre rapport n'est pas encore prêt. Revenez bientôt.",
        pillars: {
            heading: "Deux piliers",
            subtitle: "Votre score global combine Pratique (60 %) et Résultat (40 %)."
        },
        improveScorePrompt: "Comment puis-je améliorer mon score `{{scoreName}}` ? Donne-moi des actions précises que je peux faire cette semaine.",
        howToImprovePrompt: "Comment puis-je améliorer mon impact en tant que gestionnaire ? Dis-moi sur quoi me concentrer.",
        liveRegion: {
            loading: "Chargement…"
        },
        feedback: {
            heading: "Comment est ce rapport ?",
            description: "Ce rapport est nouveau et encore en bêta. Un retour rapide de votre part influence ce que nous livrons.",
            accurate: "Ce rapport est utile",
            inaccurate: "Ce rapport n'est pas utile",
            placeholder: "Quelque chose à changer ? Optionnel.",
            submit: "Envoyer le retour",
            thanks: "Merci, nous avons enregistré votre retour."
        }
    },
    ManagerImpactOverallScoreCard: {
        heading: "Mon dernier score de gestion",
        outOf: "/ {{max}}",
        status: {
            great: "Excellent",
            needsWork: "À améliorer",
            noData: "Pas encore assez de données"
        }
    },
    ManagerImpactPillarCard: {
        practice: {
            title: "Pratique",
            description: "Ce que vous contrôlez. Travaillez sur ceux-ci maintenant — ils améliorent votre score immédiatement."
        },
        outcome: {
            title: "Résultat",
            description: "Ce qui suit. Il n'évolue que lorsque votre pratique se maintient dans le temps."
        },
        outOf: "/ {{max}}",
        composedOf: "Composé de",
        list: {
            ariaLabel: "Signaux composant votre score {{pillar}}"
        },
        status: {
            noData: "Pas encore assez de données"
        }
    },
    ManagerImpactComposingScoreRow: {
        status: {
            great: "Excellent",
            needsWork: "À améliorer",
            noData: "Pas encore assez de données"
        },
        improveThisScore: "Obtenir des suggestions",
        signals: {
            "reply-rate-from-feedback": "Taux de réponse aux feedback",
            "response-time-from-feedback": "Temps de réponse aux feedback",
            "review-submission-rate": "Taux de soumission des évaluations",
            "goals-updated-hygiene": "Fréquence de mise à jour des objectifs",
            "recognition-sent": "Reconnaissance donnée",
            "my-review-score": "Mon score d'évaluation",
            "overall-review-score": "Score d'évaluation global",
            "enps-from-pulse": "eNPS de Pulse",
            "goal-attainment": "Atteinte des objectifs",
            "relationship-with-manager": "Relation avec le gestionnaire"
        },
        descriptions: {
            "reply-rate-from-feedback": "Le nombre de feedbacks et de messages de vos subordonnés directs auxquels vous avez répondu au cours du dernier mois.",
            "response-time-from-feedback": "Le temps moyen que vous avez pris pour répondre aux feedbacks de vos subordonnés directs au cours du dernier mois.",
            "review-submission-rate": "La part de vos subordonnés directs pour qui vous avez soumis à temps la dernière évaluation due.",
            "goals-updated-hygiene": "La part de vos objectifs d'équipe et de ceux de vos subordonnés directs qui sont maintenus à jour.",
            "recognition-sent": "Le nombre de vos subordonnés directs que vous avez reconnus au cours du dernier mois.",
            "my-review-score": "Votre propre score d'évaluation — la note que vous a donnée votre gestionnaire immédiat (la personne dont vous relevez). Nous considérons ce score excellent lorsqu'il atteint 70 % de l'échelle d'évaluation (pour une échelle sur 5, 3.5 sur 5).",
            "overall-review-score": "Le score moyen des dernières évaluations de performance complétées de vos subordonnés directs. Nous considérons ce score excellent lorsqu'il atteint 70 % de l'échelle d'évaluation (pour une échelle sur 5, 3.5 sur 5).",
            "enps-from-pulse": "La probabilité que vos subordonnés directs recommandent l'entreprise comme lieu de travail.",
            "goal-attainment": "La part des objectifs atteints, parmi ceux dont vous ou vos subordonnés directs êtes propriétaires.",
            "relationship-with-manager": "Le score de relation avec le gestionnaire de vos subordonnés directs, selon Pulse."
        }
    },
    ManagerImpactSignalInfo: {
        label: "À propos de {{signal}}"
    },
    ManagerImpactLowConfidenceFlag: {
        label: "Confiance faible — participation limitée au sondage"
    },
    HomeManagerImpactCard: {
        liveRegion: {
            loading: "Chargement de votre rapport d'impact"
        },
        eyebrow: "Nouveau rapport",
        cta: "Mon rapport d'impact",
        insight: {
            improve: "Vous pouvez progresser en tant que gestionnaire en travaillant sur {{opportunityLabel}}. Consultez votre rapport pour voir comment.",
            praise: "Vous êtes un excellent gestionnaire. Pour aller encore plus loin, concentrez-vous sur {{opportunityLabel}}.",
            empty: "Nous recueillons encore des données sur vos subordonnés directs. Consultez votre rapport pour voir ce qui est suivi."
        },
        opportunityLabels: {
            "reply-rate-from-feedback": "votre taux de réponse aux feedback",
            "response-time-from-feedback": "la rapidité de vos réponses aux feedback",
            "review-submission-rate": "votre taux de soumission des évaluations",
            "goals-updated-hygiene": "la fréquence de mise à jour de vos objectifs",
            "recognition-sent": "la reconnaissance que vous accordez à vos subordonnés directs",
            "my-review-score": "votre propre score d'évaluation",
            "overall-review-score": "le score d'évaluation de vos subordonnés directs",
            "enps-from-pulse": "l'eNPS de vos subordonnés directs",
            "goal-attainment": "l'atteinte des objectifs de vos subordonnés directs",
            "relationship-with-manager": "la relation de vos subordonnés directs avec vous"
        }
    }
};
